import { RecordScreenFormCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenFormCard";
import { ProDriverDetailsForm } from "@/app/ProDrivers/Drivers/Forms/ProDriverDetailsForm";
import { DescriptionList } from "@/lib/Components/DescriptionList/DescriptionListCard";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useProDriverRecord } from "@/app/ProDrivers/Drivers/Hooks/useProDriverRecord";

export function ProDriverDetailScreen() {
  const record = useProDriverRecord();

  return (
    <>
      <RecordScreenCard title={"User"}>
        <DescriptionList
          items={[
            {
              key: "name",
              value: record.name,
            },
            {
              key: "email",
              value: record.email,
            },
            {
              key: "phone",
              value: record.phone,
            },
          ]}
        />
      </RecordScreenCard>

      <RecordScreenFormCard
        title={"Details"}
        initialValues={{
          bio: record?.bio ?? "",
          basedIn: {
            connect: record.basedIn.id,
          },
        }}
        onSubmit={() => {
          alert("NYI");
        }}
      >
        <ProDriverDetailsForm />
      </RecordScreenFormCard>
    </>
  );
}
